module.exports = __webpack_public_path__ + "img/bg_agent.d0f1a665.jpg";